import React from 'react';

export function ReportsPage() {
  return (
    <div>
      <p>You are in Reports</p>
    </div>
  );
}
